export default {
  header: "Nice to meet you",
  title1: "I'm",
  title2: 'Julien Souki-Léon',
  subtitle: "Full-stack software engineer",
  link1: 'Get to know me',
  link2: 'Shoot me a message',
};
